import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/addOns/license.addOns.revoke.mutation.gql"
import type {
  LicenseAddOnRevokeMutation,
  LicenseAddOnRevokeMutationVariables,
} from "@/v2-backoffice-client/license/addOns/__types__/license.addOns.revoke.mutation"

type Options = MutationHookOptions<
  LicenseAddOnRevokeMutation,
  LicenseAddOnRevokeMutationVariables
>

export function useLicenseAddOnRevokeMutation(options?: Options) {
  return useMutation<
    LicenseAddOnRevokeMutation,
    LicenseAddOnRevokeMutationVariables
  >(mutation, options)
}
